export const MAX_SMALL_FILE_SIZE = 1024 * 1024; // 1MB in bytes

export const DEFAULT_COLOR = "#7856d2";
